import { Questionnaire, QuestionnaireField } from '../types';

export const mockQuestionnaireFields: QuestionnaireField[] = [
  {
    id: 'qf-1',
    questionnaireId: 'q-1',
    fieldName: 'Student Name',
    fieldType: 'text',
    fieldOrder: 1,
    required: true,
    createdAt: new Date('2024-01-01'),
  },
  {
    id: 'qf-2',
    questionnaireId: 'q-1',
    fieldName: 'Grade Level',
    fieldType: 'text',
    fieldOrder: 2,
    required: true,
    createdAt: new Date('2024-01-01'),
  },
  {
    id: 'qf-3',
    questionnaireId: 'q-1',
    fieldName: 'T-Shirt Size',
    fieldType: 'multiselect',
    options: 'XS,S,M,L,XL,XXL',
    fieldOrder: 3,
    required: true,
    createdAt: new Date('2024-01-01'),
  },
  {
    id: 'qf-4',
    questionnaireId: 'q-2',
    fieldName: 'Dietary Restrictions',
    fieldType: 'multiselect',
    options: 'None,Vegetarian,Vegan,Gluten-Free,Dairy-Free,Nut Allergy',
    fieldOrder: 1,
    required: false,
    createdAt: new Date('2024-01-01'),
  },
  {
    id: 'qf-5',
    questionnaireId: 'q-2',
    fieldName: 'Emergency Contact',
    fieldType: 'text',
    fieldOrder: 2,
    required: true,
    createdAt: new Date('2024-01-01'),
  },
  {
    id: 'qf-6',
    questionnaireId: 'q-2',
    fieldName: 'Emergency Phone',
    fieldType: 'text',
    fieldOrder: 3,
    required: true,
    createdAt: new Date('2024-01-01'),
  },
];

export const mockQuestionnaires: Questionnaire[] = [
  {
    id: 'q-1',
    name: 'Spirit Wear Information',
    description: 'Collect information for spirit wear orders',
    fields: mockQuestionnaireFields.filter(f => f.questionnaireId === 'q-1'),
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'q-2',
    name: 'Field Trip Registration',
    description: 'Required information for field trip participants',
    fields: mockQuestionnaireFields.filter(f => f.questionnaireId === 'q-2'),
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
];
